import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated } from "@azure/msal-react";
import ErrorHandler from "components/errorHandler/index";
import Header from "components/header/index";
import Loader from "components/loader/index";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import {
  logoutSuccess,
  setAccount,
  setOmsValidation,
  setTnc,
} from "reduxStore/features/authSlice";
import { fetchUserData } from "reduxStore/apis/index";
import { Button, Divider, Form, Input, Modal, Typography, message } from "antd";
import logo from "assets/logos/myOUTFRONT.png";
import logo1 from "assets/logos/myOUTFRONT.webp";
import { UserOutlined } from '@ant-design/icons';
import { updateUserDataXhr, validateBillToAccount } from "components/apiHandler";
import { msalInstance } from "index";
import { encryptData, decryptData } from "components/encryptionHandler";
import TermsOfUse from "components/TermsOfUse";
import ScrollToAnchor from "components/scrollHandler";
import { Footer } from "components/footer";

const ProtectedRouter = () => {
  const isAuthenticated = useIsAuthenticated();
  const {
    initLoading,
    loading,
    userDatafetched,
    omsValidation,
    user,
    tnc,
    fetchingData,
    fetchedData,
    isAuthenticated: isAuth,
    accessToken
  } = useSelector((state) => state.auth);
  const encOmsData = localStorage.getItem("OmsValidation");
  const encTncData = localStorage.getItem("tnc");
  const encRedirectData = sessionStorage.getItem("redirectInfo");
  const [BillToAccount, setBillToAccount] = useState(user?.BillToAccount);
  const [openTnc, setOpenTnc] = useState(false);
  let localOmsValidation = useMemo(() => decryptData(encOmsData) || [], [encOmsData]);
  let localTnc = useMemo(() => decryptData(encTncData) || [], [encTncData]);
  let redirectInfo = useMemo(() => decryptData(encRedirectData) || {}, [encRedirectData]);
  const dispatch = useDispatch();
  const [messageApi, messageHolder] = message.useMessage()
  const [form] = Form.useForm();
  const { REACT_APP_MSAL_EXTENSION_ID } = process.env;

  const validateFields = (_, value) => {
    const invoiceNo = form.getFieldValue("invoiceNo");
    const contractNo = form.getFieldValue("contractNo");
    if (!invoiceNo && !contractNo) {
      return Promise.reject('Please fill in at least one of the two fields.')
    }
    return Promise.resolve();
  }

  const handleSubmit = async (e) => {
    e?.preventDefault();
    messageApi.open({
      type: "loading",
      content: "Validating Information...",
      key: "loadingMessage",
      duration: 0
    })
    let res = {
      onGoing: true,
      success: false,
      error: false,
      errorMessage: null,
      contractNoSelected: false,
      contractNo: null,
      invoiceNoSelected: true,
      invoiceNo: null,
      email: user?.mail
    }
    try {
      await form.validateFields();
      let values = form.getFieldsValue();
      Object.keys(values).forEach(k => values[k] = typeof values[k] == 'string' ? values[k].trim() : values[k]); 

      values = {
        ...values,
        billToAccount: BillToAccount
      }
      const response = await validateBillToAccount(values);
      if (response && response?.code === 1) {
        messageApi.open({
          type: "error",
          content: response?.message,
        })
        res = {
          ...res,
          onGoing: true,
          success: false,
          error: true,
          errorMessage: response?.message,
          contractNoSelected: values?.contractNo ? true : false,
          contractNo: values?.contractNo,
          invoiceNoSelected: values?.invoiceNo ? true : false,
          invoiceNo: values?.invoiceNo
        }

      } else {
        if (BillToAccount !== user?.BillToAccount) {
          messageApi.open({
            type: "loading",
            content: "Updating Information...",
            key: "loadingMessage",
            duration: 0
          })
          const BillProp = `extension_${REACT_APP_MSAL_EXTENSION_ID}_BillToAccount`
          const updatePayload = {
            [BillProp]: BillToAccount
          }
          await updateUserDataXhr({ accessToken, userId: user?.id, payload: updatePayload });
          dispatch(setAccount(BillToAccount));
        }
        messageApi.open({
          type: "success",
          content: "Validation Successfull",
        });
        res = {
          ...res,
          onGoing: false,
          success: true,
          error: false,
          errorMessage: null,
          contractNoSelected: values?.contractNo ? true : false,
          contractNo: values?.contractNo,
          invoiceNoSelected: values?.invoiceNo ? true : false,
          invoiceNo: values?.invoiceNo
        }
      }

      if (localOmsValidation?.length === 0) {
        localStorage.setItem("OmsValidation", encryptData([res]));
      } else {
        localOmsValidation = localOmsValidation?.filter((item) => item.email !== user?.mail);
        localOmsValidation = [...localOmsValidation, res];
        localStorage.setItem("OmsValidation", encryptData(localOmsValidation));
      }
    } catch (error) {
      console.log(error);

      messageApi.open({
        type: "error",
        content: "Validation Failed",
      })
    } finally {
      dispatch(setOmsValidation(res))
      messageApi.destroy("loadingMessage")
    }

  }

  const handleAccept = (e) => {
    e?.preventDefault()
    const res = {
      onGoing: false,
      accepted: true,
      email: user?.mail
    }

    if (localTnc?.length === 0) {
      localStorage.setItem("tnc", encryptData([res]));
    } else {
      localTnc = localTnc?.filter((item) => item.email !== user?.mail);
      localTnc = [...localTnc, res];
      localStorage.setItem("tnc", encryptData(localTnc));
    }
    dispatch(setTnc(res))

  }
  const handleReject = (e) => {
    e?.preventDefault();
    msalInstance.getAllAccounts().forEach(async account => {
      await msalInstance.logoutRedirect({
        account: account,
        postLogoutRedirectUri: "/"
      })
    });
    // localStorage.clear();
    // sessionStorage.clear();
    dispatch(logoutSuccess())
  }

  useEffect(() => {
    if ((!userDatafetched && !fetchingData && !fetchedData) || (!userDatafetched && !fetchingData && fetchedData && Object.keys(redirectInfo).length > 0)) {

      dispatch(fetchUserData(Object.keys(redirectInfo).length > 0 ? redirectInfo?.accessToken : null));
    } else if (userDatafetched && !fetchingData && fetchedData) {
      const userOms = localOmsValidation?.filter((item) => item.email === user?.mail)?.[0] || {};

      if (Object.keys(userOms).length !== 0 && userOms?.email === user?.mail) {
        dispatch(setOmsValidation(userOms))
      } else {
        dispatch(setOmsValidation({ onGoing: true }))
      }
    }
  }, [isAuth, isAuthenticated, localOmsValidation, user?.mail, userDatafetched, fetchingData, fetchedData, redirectInfo]);

  useEffect(() => {
    if (omsValidation.success && !tnc.accepted && userDatafetched && !fetchingData && fetchedData) {
      const userTnc = localTnc?.filter((item) => item.email === user?.mail)?.[0] || {};
      if (Object.keys(userTnc).length !== 0 && userTnc?.email === user?.mail) {
        dispatch(setTnc(userTnc))
      } else {
        dispatch(setTnc({ onGoing: true }))
      }
    }

  }, [omsValidation.success, localTnc, tnc.accepted, user?.mail, userDatafetched, fetchingData, fetchedData])

  useEffect(() => {
    setBillToAccount(user?.BillToAccount)
  }, [user?.BillToAccount])

  return (
    <ErrorHandler>
      {messageHolder}
      <Loader loading={initLoading}>
        <UnauthenticatedTemplate>
          <div className="App" data-auth="false">
            <ScrollToAnchor />
            <Header />
            <Outlet />
            <Footer />
          </div>
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <Modal
            title={
              <img
                className="logo"
                src={`${logo} 768w`}
                srcSet={`${logo1} 450w,${logo} 768w`}
                sizes="(min-width:450px) 450px,(min-width:768px) 768px"
                alt="myOUTFRONT.com"
              />
            }
            destroyOnClose
            key={"omsPopup"}
            maskClosable={false}
            rootClassName="omsPopup"
            closable={false}
            centered
            open={(!initLoading && !loading && omsValidation?.onGoing && userDatafetched && !fetchingData) || false}
            footer={null}
          >
            <h3>OMS Account Verification</h3>
            <Form
              id="omsValidationForm"
              form={form}
              name="OMS VALIDATION FORM"
              layout="vertical"
              style={{ marginBlock: "1rem" }}
              fields={[{
                name: "billToAccount",
                value: BillToAccount
              }]}

            >
              <Form.Item
                label="Account Number"
                name="billToAccount"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input
                  placeholder="Enter Here..."
                  prefix={
                    <UserOutlined
                      style={{
                        color: 'rgba(0,0,0,.25)',
                      }}
                    />
                  }
                  onChange={(e) => setBillToAccount(e?.target?.value.trim())}
                // disabled
                />  
              </Form.Item>
              <Divider />
              <Form.Item
                label="Invoice Number"
                name="invoiceNo"
                rules={[
                  {
                    validator: validateFields,
                    // required: !form.getFieldValue("contractNo")?.length > 0
                  },
                ]}

              >
                <Input
                  placeholder="Enter Here..."
                
                />
              </Form.Item>
              <Divider style={{ fontWeight: "bolder" }}>or</Divider>
              <Form.Item
                label="Contract Number"
                name="contractNo"
                rules={[
                  {
                    validator: validateFields,
                    // required: !form.getFieldValue("invoiceNo")?.length > 0
                  },
                ]}
              >
                <Input
                  placeholder="Enter Here..."
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" style={{ width: "100%" }} onClick={handleSubmit}>
                  Validate
                </Button>
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            title={
              <img
                className="logo"
                src={`${logo} 768w`}
                srcSet={`${logo1} 450w,${logo} 768w`}
                sizes="(min-width:450px) 450px,(min-width:768px) 768px"
                alt="myOUTFRONT.com"
              />
            }
            destroyOnClose
            key={"tncPopup"}
            maskClosable={false}
            rootClassName="tncPopup"
            closable={false}
            centered
            open={(!initLoading && !loading && tnc?.onGoing && omsValidation?.success && userDatafetched && !fetchingData) || false}
            // open={true}
            footer={null}
          >
            <Typography.Title level={4} >
              Please review the Terms & Conditions <br/><br/><span onClick={() => setOpenTnc(true)} style={{ color: "var(--purple500)", cursor: "pointer" }}>Terms & Conditions</span>.<br/><br/>
            </Typography.Title>
            <div style={{ display: "flex", gap: ".5rem", width: "100%" }}>
              <Button key={"back"} type="default" style={{ flex: 1 }} onClick={handleReject}>
                Cancel
              </Button>
              <Button key={"submit"} type="primary" style={{ flex: 1 }} onClick={handleAccept}>
                Accept
              </Button>
            </div>
          </Modal>
          <Modal
            title={
              <img
                className="logo"
                src={`${logo} 768w`}
                srcSet={`${logo1} 450w,${logo} 768w`}
                sizes="(min-width:450px) 450px,(min-width:768px) 768px"
                alt="myOUTFRONT.com"
              />
            }
            open={(!initLoading && !loading && tnc?.onGoing && omsValidation?.success && userDatafetched && !fetchingData && openTnc) || false}
            onCancel={() => setOpenTnc(false)}
            destroyOnClose
            centered
            width={"100%"}
            footer={[
              <Button key="back1" onClick={handleReject}>
                Cancel
              </Button>,
              <Button key="submit1" type="primary" loading={loading} onClick={handleAccept}>
                Accept
              </Button>,
            ]}
            className="tncExpandPopup"
          >
            <TermsOfUse popup />
          </Modal>
          <div className="App" data-auth="true">
            <Header />
            <ScrollToAnchor />
            <Outlet />
            <Footer />
          </div>
        </AuthenticatedTemplate>
        {/* <NavBar /> */}
      </Loader>
    </ErrorHandler>
  );
};

export default ProtectedRouter;
